<template>
  <div>
    <section :class=getSelectThemeTypeCSSClasses>
      <div class="select-category__content">
        <h1 v-if=isFinalRound>{{ getTranslations.home_select_theme_last_round_msg1 }}<br>{{ getTranslations.home_select_theme_last_round_msg2 }}</h1>
        <h1 v-else-if=isCurrentThemeChooser>{{ getTranslations.home_select_theme_choose_a_theme }}</h1>
        <h1 v-else>{{ getTranslations.home_select_theme_wait_msg }}<br>{{ getTranslations.home_select_theme_wait_opponent }}</h1>
        <div class="select-category__content__icons">
          <div v-for="theme in themes" :key="theme.iconUrl" :class=getThemePlayedCSSClasses(theme)>
            <a @click.prevent="storeAndSendSelectedTheme(theme)" href="#">
              <img :src="theme.iconUrl" alt="">
              <span class="cat-item__name">{{ theme.displayMultilanguageText }}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
    <div class="square-loader">
      <svg width="100%" height="100%">
        <rect width="100%" height="100%"/>
      </svg>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import shuffle from 'knuth-shuffle-seeded';
import webSocket from '@/common/webSocket';
import { squareLoaderAnimation } from '@/common/jQuery';
import { ParseResponseMixin, GameMixin2, GameMixin3 } from '@/common/mixins/game';

export default {
  name: 'select-theme',
  mixins: [ParseResponseMixin, GameMixin2, GameMixin3],
  data() {
    return {
      themes: [],
      availableThemes: [],
      availableThemesHTMLElementIndices: [],
      selectedThemeID: null,
      stompClient: null,
      subscription: null,
      timer: null,
    };
  },
  created() {
    // console.clear();
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.setCurrentThemeChooserMSISDN();
    console.log('this.currentThemeChooserMSISDN:', this.currentThemeChooserMSISDN);
    console.log('this.isCurrentThemeChooser:', this.isCurrentThemeChooser);
    console.log('this.isFinalRound:', this.isFinalRound);

    this.themes = this.isHomePlayer ? this.homePlayerCurrentThemes : this.awayPlayerCurrentThemes;
    for (let i = 0; i < this.themes.length; i += 1) {
      if (!this.themes[i].used) {
        if (this.isHomePlayer) {
          this.availableThemes.push(this.themes[i]);
        }
        this.availableThemesHTMLElementIndices.push(i + 1);
      }
    }
    console.log('this.availableThemesHTMLElementIndices:', this.availableThemesHTMLElementIndices);
    this.getSelectedTheme();
  },
  mounted() {
    console.log('in SelectTheme mounted hook');
    this.selectedThemeID = null;
    squareLoaderAnimation();
    if (this.isFinalRound) {
      this.autoChooseThemeAnimation();
    }
    // fix animation on window resize
    // eslint-disable-next-line
    $(window).resize(() => squareLoaderAnimation());
  },
  methods: {
    ...mapMutations('game', [
      'setCurrentThemeChooserMSISDN',
      'setPlayersCurrentSelectedTheme',
    ]),
    getSelectedTheme() {
      // console.clear();
      console.log(`Subscribing to channel: /topic/categorySelected/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/categorySelected/${this.gameID}`, (response) => {
        this.subscription.unsubscribe();
        console.log('[SelectTheme] Inside categorySelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.data;
        console.log('responseData:', responseData);
        if (responseData.gameDTO.gameStateEnum === 'CATEGORY_SELECTED') {
          console.log('gameStateEnum: CATEGORY_SELECTED');
          const homeThemeDTOList = responseData.gameDTO.homeUserDetails.themeDTOList;
          const awayThemeDTOList = responseData.gameDTO.awayUserDetails.themeDTOList;
          // get the selected theme (as object) from the array of objects and save them in a payload object
          this.setPlayersCurrentSelectedTheme({
            homePlayerCurrentSelectedTheme: homeThemeDTOList.filter(obj => obj.id === responseData.themeId)[0],
            awayPlayerCurrentSelectedTheme: awayThemeDTOList.filter(obj => obj.id === responseData.themeId)[0],
          });
          clearInterval(this.timer);
          this.normalTransition = true;
          console.log('going to selectedTheme page');
          this.$router.replace('/selectedTheme');
        }
      });
    },
    storeAndSendSelectedTheme(theme) {
      if (!theme.used) {
        console.log('theme:', theme);
        this.selectedThemeID = theme.id;
        console.info(`Invoking API: ${window.location.origin}/api/categorySelected?gameId=${this.gameID}&selectedCategoryId=${this.selectedThemeID})`);
        this.$axios.get(`api/categorySelected?gameId=${this.gameID}&selectedCategoryId=${this.selectedThemeID}`);
      }
    },
    autoChooseThemeAnimation() {
      let previousRandomIndex = 1;
      let currentRandomIndex = 1;
      this.timer = setInterval(() => {
        shuffle(this.availableThemesHTMLElementIndices, new Date());
        currentRandomIndex = this.availableThemesHTMLElementIndices[0] === previousRandomIndex
          ? this.availableThemesHTMLElementIndices[1]
          : this.availableThemesHTMLElementIndices[0];
        previousRandomIndex = currentRandomIndex;
        console.log(`currentRandomIndex: ${currentRandomIndex}`);
        /* eslint-disable */
        $('.cat-item').removeClass('active');
        $('.cat-item:nth-child(' + currentRandomIndex + ')').addClass('active');
        /* eslint-enable */
      }, 500);
    },
    getThemePlayedCSSClasses(theme) {
      const classes = ['cat-item'];
      if (theme.used) {
        classes.push('played');
      }
      if (this.isFinalRound) {
        classes.push('cat-item-auto');
      }
      return classes;
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'currentThemeChooserMSISDN',
      'currentRoundNumber',
      'homePlayerCurrentThemes',
      'awayPlayerCurrentThemes',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isCurrentThemeChooser',
      'isFinalRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    getSelectThemeTypeCSSClasses() {
      const classes = ['select-category'];
      if (this.isFinalRound || !this.isCurrentThemeChooser) {
        classes.push('select-category--waiting');
      }
      return classes;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SelectTheme.vue